import { RenderInstruction, ValidateResult, ValidationRenderer } from 'aurelia-validation';

export class BootstrapControlRenderer implements ValidationRenderer {
  render(instruction: RenderInstruction) {
    const isValid = (e: Element) => ['INPUT', 'SELECT', 'TEXTAREA'].includes(e.tagName);

    for (const { result, elements } of instruction.unrender)
      for (const element of elements)
        if (isValid(element))
          this.remove(element, result);

    for (const { result, elements } of instruction.render)
      for (const element of elements)
        if (isValid(element))
          this.add(element, result);
  }

  private add(control: Element, result: ValidateResult) {
    if (result.valid) {
      if (!control.classList.contains('is-invalid'))
        control.classList.add('is-valid');
    }

    else {
      control.classList.remove('is-valid');
      control.classList.add('is-invalid');

      const message = document.createElement('div');
      message.className = 'invalid-feedback';
      message.textContent = result.message;
      message.id = `validation-message-${result.id}`;
      control.parentElement.appendChild(message);
    }
  }

  private remove(control: Element, result: ValidateResult) {
    if (result.valid)
      control.classList.remove('is-valid');

    else {
      const parent = control.parentElement;
      const message = parent.querySelector(`#validation-message-${result.id}`);

      if (message)
        parent.removeChild(message);
      if (parent.querySelectorAll('.invalid-feedback').length === 0)
        control.classList.remove('is-invalid');
    }
  }
}
